import React, { useState, useEffect } from "react";

import _ from "lodash";
import { Row } from "react-bootstrap";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";

import DownloadButton from "./downloadButton";
import LegislativeView from "./legislativeView";
import { fetchLegislators, addCouncilMembers } from "../utilities/apiWrapper";
import {
  genderOptions,
  raceOptions,
  fieldNames,
  races,
  parties,
} from "../utilities/constants";
import utils from "../utilities/utils";

const { BOROUGH } = fieldNames;

function NycCouncil(props) {
  const [genderFilter, setGenderFilter] = useState("");
  const [raceFilter, setRaceFilter] = useState("");
  const [committeeFilter, setCommitteeFilter] = useState([]);

  let people = props.people;
  let fetchLegislatorsAction = props.fetchLegislatorsAction;
  let governmentBody = props.governmentBody;

  useEffect(() => {
    if (people.length === 0) {
      fetchLegislatorsAction({
        governmentBody,
        addLegislatorAction: addCouncilMembers,
      });
    }
  }, [governmentBody, people.length, fetchLegislatorsAction]);

  function boroGroupCounts(borough) {
    if (!genderFilter && !raceFilter && !committeeFilter) {
      return props[`${borough}`].length;
    } else {
      return utils.updateCounts({
        peopleByGroup: props[`${borough}`],
        genderFilter,
        raceFilter,
        committeeFilter,
      });
    }
  }

  let brooklynCount = boroGroupCounts("brooklyn");
  let queensCount = boroGroupCounts("queens");
  let manhattanCount = boroGroupCounts("manhattan");
  let bronxCount = boroGroupCounts("bronx");
  let statenCount = boroGroupCounts("staten");

  return (
    <div className="houses">
      <DownloadButton governmentBody={props.governmentBodyShort} />

      <div className="house-components">
        <div className="select-container">
          <Select
            className="select-item"
            isMulti
            placeholder="Filter by Gender..."
            options={genderOptions}
            onChange={(event) =>
              setGenderFilter(event.map((choice) => choice.value))
            }
          />
          <Select
            className="select-item"
            isMulti
            placeholder="Filter by Race..."
            options={raceOptions}
            onChange={(event) =>
              setRaceFilter(event.map((choice) => choice.value))
            }
          />

          {props.showCommitteeFilter && (
            <Select
              className="select-item"
              isMulti
              placeholder="Filter by Committee..."
              options={utils.setCommitteeOptions(props.people)}
              onChange={(event) =>
                setCommitteeFilter(event.map((choice) => choice.value))
              }
            />
          )}
        </div>
        <LegislativeView
          governmentBody={props.governmentBody}
          groups={{
            Brooklyn: props.brooklyn,
            Queens: props.queens,
            Manhattan: props.manhattan,
            Bronx: props.bronx,
            "Staten Island": props.staten,
          }}
          groupCount={{
            Brooklyn: brooklynCount,
            Queens: queensCount,
            Manhattan: manhattanCount,
            Bronx: bronxCount,
            "Staten Island": statenCount,
          }}
          sm={[12, 12, 12, 12, 12]}
          md={[3, 3, 2, 2, 2]}
          lg={[3, 3, 2, 2, 2]}
          genderFilter={genderFilter}
          raceFilter={raceFilter}
          committeeFilter={committeeFilter}
          legendCategories={utils.legendCategories}
        />
        <Row>
          <div className="legend">
            <h4>Legend</h4>
            {utils.renderLegend(races, parties, props.people, "Councilmembers")}
          </div>
        </Row>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  const people = _.get(state, ["council"], []);
  const brooklyn = people.filter((person) => {
    return person.fields[BOROUGH].includes("Brooklyn");
  });
  const queens = people.filter((person) => {
    return person.fields[BOROUGH].includes("Queens");
  });
  const manhattan = people.filter((person) => {
    return person.fields[BOROUGH].includes("Manhattan");
  });
  const bronx = people.filter((person) => {
    return person.fields[BOROUGH].includes("Bronx");
  });
  const staten = people.filter((person) => {
    return person.fields[BOROUGH].includes("Staten Island");
  });

  return {
    people: utils.sortByRacePartyAndName(people),
    brooklyn: utils.sortByRacePartyAndName(brooklyn),
    queens: utils.sortByRacePartyAndName(queens),
    manhattan: utils.sortByRacePartyAndName(manhattan),
    bronx: utils.sortByRacePartyAndName(bronx),
    staten: utils.sortByRacePartyAndName(staten),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchLegislatorsAction: bindActionCreators(fetchLegislators, dispatch),
  };
}

const componentCreator = connect(mapStateToProps, mapDispatchToProps);
export default componentCreator(NycCouncil);
